import Swiper from '../../node_modules/swiper';

import { Autoplay, Navigation } from 'swiper/modules';

// hear it from our clients
export default function testimonials() {
	return new Swiper('.testimonial-slider .swiper', {
		slidesPerView: 1,
		modules: [Autoplay, Navigation],
		autoplay: {
			delay: 2000,
			pauseOnMouseEnter: true,
			disableOnInteraction: false,
		},
		spaceBetween: 30,
		loop: true,
		navigation: {
			nextEl: '.testimonial-slider .swiper-button-next',
			prevEl: '.testimonial-slider .swiper-button-prev',
		},
		breakpoints: {
			1050: {
				slidesPerView: 3,
				centeredSlides: true,
			},
			650: {
				slidesPerView: 2,
			},
		},
	});
}
